
/**
 *
 *      Data-driven UI logic for multi-facet search interface
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created on 05/11/2018
 *      Modified on 03/04/2019
 */

/**
 * Filter search results by the checked data types
 */
function refineDataTypes() {

    var checkedTypes = [],
        types,
        type,
        records,
        i;

    // Find all checked types
    types = $('#available-filters .search-checkbox');
    if ( types ) {
        for ( i = 0; i < types.length; i++ ) {
            type = types[i];
            if ( $(type) && $(type).is(":checked") ) {
                checkedTypes.push( type );
            }
        }

        // Remove all type filters and reload the search page
        removeAllTypeFilters();

        if ( checkedTypes.length > 0 ) {

            // Add checked types to filters
            addTypeFiltersFromCheckbox( checkedTypes );

        }

        // Update URL based on global filters without redirecting
        updateURLFromFilters( false );

        // Re-do the search
        records = App.globalState.searchResults;
        records.reset( null );
        records.getRecords( modifyQuery( App.globalState.query ), 0, App.globalState.pageSize, successResponseCallback );

    }
}

/**
 * Add all of checked types to global filters
 * @param types {Array} - array of checked data type checkboxes
 */
function addTypeFiltersFromCheckbox( types ) {

    var i;

    if ( types ) {
        for ( i = 0; i < types.length; i++ ) {
            addTypeFilterFromCheckbox( $(types[i]) );
        }
    }
}

/**
 * Add one type filter from a checked checkbox to global filters
 * @param el {object} - checkbox DOM element
 */
function addTypeFilterFromCheckbox( el ) {
    var typeLink,
        typeLinkEl,
        value,
        displayValue;

    if ( el ) {
        typeLink = el.next('.document-filter');
        if ( typeLink && typeLink.length === 1 ) {
            typeLinkEl = typeLink[0];
            if ( typeLinkEl ) {

                value = typeLinkEl.getAttribute( "name" );
                displayValue = typeLinkEl.getAttribute( "label" );

                if ( value ) {
                    addFilterToGlobal( "type", "Type", value, displayValue, "eq", "string" );
                }
            }
        }
    }
}

/**
 * Get a unique array of filters from the global filters array
 * @return {Array} - array of filters with unique elements
 */
function getUniqueFilters() {

    var a,
        i,
        j;

    if ( App && App.globalState && App.globalState.currentFilters && App.globalState.currentFilters.models ) {
        var array = App.globalState.currentFilters.models;

        if (array) {
            a = array.concat();
            for (i = 0; i < a.length; i++) {
                for (j = i + 1; j < a.length; j++) {
                    if (a[i].get("field") === a[j].get("field") && a[i].get("value") === a[j].get("value")) {
                        j--;
                        a.splice(j, 1);
                    }
                }
            }
        }
    }
    return a;
}

/**
 * Get all available data types from Search and display them using DMR models
 */
function getInitialDataTypes() {

    var alias,
        fuzziness,
        start,
        query,
        pagesize,
        page,
        url,
        data;

    if ( App && App.globalState ) {
        start = App.globalState.currentPage > 1 ? (App.globalState.currentPage - 1) * App.globalState.pageSize : 0;
        query = App.globalState.query;
        pagesize = App.globalState.pageSize;
        page = Math.floor( start / pagesize ) + 1;
        url = App.globalState.searchAPIBase;

        data = {};
        data.q = query;

        // Exclude the type to get all available types

        data.page = page;
        data.pagesize = pagesize;


        alias = App.globalState.alias;

        if ( alias ) {
            data.alias = alias;
        }

        // Check fuzzy / exact match search toggle
        if ( isFuzzySet() ) {
            url += '/fuzzy';

            // Call shared styles to get the fuzziness degree value
            if ( typeof getFuzzyDegree !== "undefined" ) {
                fuzziness = getFuzzyDegree();
            }

            if ( fuzziness && fuzziness !== "auto" ) {
                data.fuzziness = fuzziness;
            }
        }

        $.ajax({
            url: url,
            data: data,
            dataType: 'json'
        })
        .done( function ( response ) {

            $('#sub-menu').show();
            // Display initial data types
            displayInitialDataTypes( response );
        })
        .fail( function ( jqXHR ) {
            console.log("Error: Getting initial data types from search failed");
        });
    }
}

/**
 * Display checked checkboxes that already have been selected
 */
function showSelectedTypes() {

    var typeURL = getTypeStringFromURL( Backbone.history.getFragment() ),
        types,
        typesArray,
        typesString,
        group,
        i,
        j;

    // Check the URL type
    if ( typeURL ) {
        types = typeURL.split(",");

        if (types) {
            for ( i = 0; i < types.length; i++ ) {
                checkTypeCheckbox( types[ i ] );
            }
        }
    }

    // Check the URL group
    group = getGroupNameFromURL();

    // Select all types that are in the global group type array
    if ( group && App.globalState.TypeGroups ) {
        typesArray = App.globalState.TypeGroups[ group ];

        if ( typesArray ) {
            typesString = typesArray.split(',');
            if ( typesString ) {
                for ( j = 0; j < typesString.length; j++ ) {
                   checkTypeCheckbox( typesString[ j ] );
                }
            }
        }
    }
}

/**
 * Check data type checkbox
 * @param type {string} - type name
 */
function checkTypeCheckbox( type ) {
    var link,
        checkbox,
        checkboxes;

    if ( type ) {
        // Find type links
        link = $('.document-filter[name="' + type + '"]');
        if ( link ) {
            checkboxes = link.siblings('.search-checkbox');
            if ( checkboxes && checkboxes.length === 1 ) {
                checkbox = checkboxes[ 0 ];
                if ( checkbox ) {
                    checkbox.setAttribute( "checked", "checked" );
                }
            }
        }
    }
}